import { IconRender, InheritProps } from '../../IconRender';

export function GridIcon(props: InheritProps) {
  return (
    <IconRender
      {...props}
      childrenRender={(color: string) => (
        <>
          <rect x="1" y="1" width="48" height="78" rx="7" fill="#343434" stroke={color} strokeWidth="4"/>
          <path d="M2 64H48V72C48 75.3137 45.3137 78 42 78H8C4.68629 78 2 75.3137 2 72V64Z" fill="#D9D9D9"/>
          <rect x="6" y="67" width="7" height="7" rx="1" fill="#343434"/>
          <rect x="16" y="67" width="7" height="7" rx="1" fill="#343434"/>
          <rect x="26" y="67" width="7" height="7" rx="1" fill="#343434"/>
          <rect x="36" y="67" width="7" height="7" rx="1" fill="#343434"/>
        </>
      )}
    />
  );
}
